module.exports = __webpack_public_path__ + "assets/favicons/company-icon.svg";